export interface LocationSettings {
	location_id: number;
	primary_color: string;
	logo: string;
}

export function getLocationSettingsFromStorage(): LocationSettings | null {
	if (typeof window === "undefined") return null;

	const stored = localStorage.getItem("location_settings");
	if (!stored) return null;

	try {
		const settings = JSON.parse(stored);
		return {
			location_id: Number.parseInt(settings.location_id),
			primary_color: settings.primary_color,
			logo: settings.logo,
		};
	} catch {
		return null;
	}
}

export function setLocationSettingsInStorage(settings: LocationSettings): void {
	if (typeof window === "undefined") return;

	localStorage.setItem("location_settings", JSON.stringify(settings));
}

export function clearLocationSettingsFromStorage(): void {
	if (typeof window === "undefined") return;

	localStorage.removeItem("location_settings");
}
